import './footer.css';

const phoneDisplay = '050-204-4391';
const phoneIntl = '+972502044391';
const whatsappIntl = '+972 50-204-4391';

export function Footer() {
  return (
    <footer className="footer" aria-label="تذييل الموقع">
      <div className="container footerInner">
        <div className="footerGrid">
          <div>
            <h3 className="footerTitle">تواصل معنا</h3>
            <p className="footerText">
              نحن جاهزون لمساعدتك في اختيار البرنامج المناسب، ومواعيد التدريب، وأي استفسار حول
              التسجيل.
            </p>
          </div>

          <div className="footerLinks">
            <div className="footerLinkRow">
              <a className="btn" href={`tel:${phoneIntl}`} aria-label="اتصال مباشر">
                اتصال: {phoneDisplay}
              </a>
              <a
                className="btn"
                href={`https://wa.me/${phoneIntl.replace('+', '')}`}
                target="_blank"
                rel="noreferrer"
                aria-label="مراسلة واتساب"
              >
                واتساب: {whatsappIntl}
              </a>
            </div>

            <div className="footerLinkRow">
              <a className="btn" href="mailto:amerp3011@gmail.com">
                البريد الإلكتروني: amerp3011@gmail.com
              </a>
            </div>

            <div className="footerLinkRow">
              <a
                className="btn"
                href="https://www.facebook.com/amerp3011"
                target="_blank"
                rel="noreferrer"
              >
                فيسبوك المدرب
              </a>
              <a
                className="btn"
                href="https://www.facebook.com/ElfahmawiBoxingCenter"
                target="_blank"
                rel="noreferrer"
              >
                فيسبوك المركز
              </a>
            </div>
          </div>
        </div>

        <div className="tiny">© {new Date().getFullYear()} مركز الملاكمة الفحماوي</div>
      </div>
    </footer>
  );
}

